var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "article-list" },
    [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md mb-2" },
            [_c("article-search")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md mb-2" },
            [_c("categoryFilter")],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("alert-infobox"),
      _vm._v(" "),
      _vm.loadingState == "completed"
        ? _c("div", [
            _c("p", [
              _vm.$store.state.textSearchQuery !== ""
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("label.results_for")) +
                        ' "' +
                        _vm._s(_vm.$store.state.textSearchQuery) +
                        '"'
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.articles.length > 0
              ? _c(
                  "table",
                  {
                    staticClass:
                      "table table-responsive-lg table-striped table-hover",
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("label.article")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("label.description")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("label.version")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("label.image")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("label.pdf")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isStaffUser ? _c("th") : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.articles, function (article) {
                        return _c("tr", [
                          _c("td", [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-4" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(article.article_number) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-8 article-name" },
                                [
                                  _c(
                                    "span",
                                    { attrs: { title: article.name } },
                                    [_vm._v(_vm._s(article.name))]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "public-name-field col-sm-12 article-name",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(article.public_name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(article.description) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(article.version))]),
                          _vm._v(" "),
                          _c("td", [
                            article.image != null
                              ? _c("img", {
                                  staticClass: "article-image",
                                  attrs: { src: article.image_download_url },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openImageModal(
                                        article.name,
                                        article.image_download_url
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            article.pdf_download_url
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "article-pdf-download",
                                    attrs: {
                                      href: article.pdf_download_url,
                                      download: article.name + ".pdf",
                                      title: _vm.$t("label.download_pdf"),
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-download" })]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.isStaffUser
                            ? _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        "/admin/articles/article/?q=" +
                                        article.article_number,
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-pencil" })]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.articles.length == 0
              ? _c("div", { staticClass: "alert alert-warning" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("label.no_articles_found")) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "div",
            {
              attrs: { name: "modal" },
              on: {
                close: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "modal-mask" }, [
                _c("div", { staticClass: "modal-wrapper" }, [
                  _c("div", { staticClass: "modal-container" }, [
                    _c(
                      "div",
                      { staticClass: "modal-header" },
                      [
                        _vm._t("header", function () {
                          return [
                            _c("h5", { staticClass: "modal-title" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.imageModal.article_label) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [
                        _vm._t("body", function () {
                          return [
                            _c("img", {
                              attrs: {
                                id: "modal-content-image",
                                src: _vm.imageModal.image_url,
                              },
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [
                        _vm._t("footer", function () {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { type: "button" },
                                on: { click: _vm.closeImageModal },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("label.close")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }